import type { Category, Product } from "../types";

export const PRODUCTS: Product[] = [
	{
		id: "tee-sunset",
		name: "Sunset Tee",
		category: "apparel",
		price: 28,
		description: "Soft cotton tee with a hand-drawn sunset graphic.",
		imageColor: "#F97316",
	},
	{
		id: "hoodie-midnight",
		name: "Midnight Hoodie",
		category: "apparel",
		price: 64,
		description: "Heavyweight hoodie in deep indigo.",
		imageColor: "#1E1B4B",
	},
	{
		id: "socks-lattice",
		name: "Lattice Socks",
		category: "apparel",
		price: 12,
		description: "A three-pack of patterned crew socks.",
		imageColor: "#D97706",
	},
	{
		id: "lamp-atrium",
		name: "Atrium Lamp",
		category: "home",
		price: 89,
		description: "Warm LED floor lamp with a walnut base.",
		imageColor: "#A16207",
	},
	{
		id: "mug-studio",
		name: "Studio Mug",
		category: "home",
		price: 18,
		description: "Thick-walled stoneware mug, 12oz.",
		imageColor: "#0E7490",
	},
	{
		id: "throw-forest",
		name: "Forest Throw",
		category: "home",
		price: 54,
		description: "Chunky knit throw in mossy green.",
		imageColor: "#065F46",
	},
	{
		id: "speaker-cove",
		name: "Cove Speaker",
		category: "electronics",
		price: 129,
		description: "Portable Bluetooth speaker with 18-hour battery.",
		imageColor: "#0F172A",
	},
	{
		id: "earbuds-drift",
		name: "Drift Earbuds",
		category: "electronics",
		price: 79,
		description: "Noise-isolating earbuds with a matte finish.",
		imageColor: "#1E293B",
	},
	{
		id: "charger-trek",
		name: "Trek Charger",
		category: "electronics",
		price: 34,
		description: "65W USB-C fast charger with foldable prongs.",
		imageColor: "#475569",
	},
];

export const CATEGORIES: Array<{ id: Category | "all"; label: string }> = [
	{ id: "all", label: "All" },
	{ id: "apparel", label: "Apparel" },
	{ id: "home", label: "Home" },
	{ id: "electronics", label: "Electronics" },
];

export function getProductById(id: string): Product | undefined {
	return PRODUCTS.find((item) => item.id === id);
}
